import actions from "./actions";

const initState = {  
  grammarDescriptions: [],
  grammarDescriptionDetail: {},
  permissions: {},
  loading: false,
  totalItems: 0,

};

export default function grammarDescriptionReducer(state = initState, action) {
  switch (action.type) {
    //#region CRUD
    case actions.GET_GRAMMARDESCRIPTIONS:
      return { ...state, loading: true, totalItems: 0 };

    case actions.GET_GRAMMARDESCRIPTIONS_SUCCESS:
      let { data, totalItems } = action.payload;
      let res = data ? data : [];
      return { ...state, grammarDescriptions: res, totalItems, loading: false };

    case actions.GET_GRAMMARDESCRIPTION_DETAIL:
      return { ...state, loading: true, totalItems: 0 };

    case actions.GET_GRAMMARDESCRIPTION_DETAIL_SUCCESS: {
      let { data } = action.payload;
      let res = data ? data : {};
      return { ...state, grammarDescriptionDetail: res, loading: false };
    }
    case actions.GRAMMARDESCRIPTION_LOADING_FALSE:{
      return { ...state,  loading: false };
    }

    default:
      return state;
  }
}
